"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Banner = function Banner(_ref) {
  var imageUrl = _ref.imageUrl,
      variant = _ref.variant,
      props = _objectWithoutPropertiesLoose(_ref, ["imageUrl", "variant"]);

  return (0, _themeUi.jsx)("div", _extends({
    className: "Banner"
  }, props, {
    sx: _extends({
      bg: 'white',
      width: '100%',
      position: 'relative'
    }, imageUrl && {
      minHeight: 11,
      backgroundImage: "url(" + imageUrl + ")",
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      position: 'relative',
      bg: 'primaryLight',
      color: 'textWhite'
    }, variant === 'overlay' && {
      color: 'textWhite',
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bg: 'primaryDark',
        opacity: 0.6
      }
    })
  }));
};

Banner.propTypes = {
  imageUrl: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['clear', 'overlay'])
};
Banner.defaultProps = {
  imageUrl: null,
  variant: 'clear'
};
var _default = Banner;
exports["default"] = _default;